const LOCAL_CATEGORY_MAP = {
    TSINX: 'Foreign Large Blend',
    TGBLX: 'Global Large-Stock Growth',
    TGPEX: 'Global Large-Stock Growth',
    TBLMX: 'Target-Date 2055',
    TBLKX: 'Target-Date 2045',
    TBLJX: 'Target-Date 2040',
    TBLHX: 'Target-Date 2035',
    TBLGX: 'Target-Date 2030',
    TBLEX: 'Target-Date 2025',
    TBLDX: 'Target-Date 2020',
    TBLCX: 'Target-Date 2015',
    TBLBX: 'Target-Date 2000-2010',
    TBLAX: 'Target-Date 2000-2010',
    TBLNX: 'Target-Date 2060',
    TBLOX: 'Target-Date 2065+',
    TBLLX: 'Target-Date 2050',
    TBLPX: 'Target-Date 2000-2010',
    TBLQX: 'Target-Date 2000-2010',
    TBLSX: 'Target-Date 2015',
    TSBAX: 'Target-Date 2020',
    TBLVX: 'Target-Date 2025',
    TBLWX: 'Target-Date 2030',
    TBLYX: 'Target-Date 2035',
    TRBLX: 'Target-Date 2040',
    TRBQX: 'Target-Date 2045',
    TRBSX: 'Target-Date 2050',
    TRBOX: 'Target-Date 2055',
    TRBNX: 'Target-Date 2060',
    TRBPX: 'Target-Date 2065+',
    TSVPX: 'Large Blend',
    TSPNX: 'Multisector Bond'
};

const mStarCategoriesOrLocal = (fund) =>
    (fund.morningStarRatings &&
        fund.morningStarRatings.morningStarCategoryName) ||
    LOCAL_CATEGORY_MAP[fund.ticker];

export default mStarCategoriesOrLocal;
